import { render, staticRenderFns } from "./popup-sync.vue?vue&type=template&id=04479112&scoped=true"
import script from "./popup-sync.vue?vue&type=script&lang=js"
export * from "./popup-sync.vue?vue&type=script&lang=js"
import style0 from "./popup-sync.vue?vue&type=style&index=0&id=04479112&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04479112",
  null
  
)

export default component.exports